module.exports = __webpack_public_path__ + "img/organizations.3b04666e.jpeg";